<script>

    import { createEventDispatcher } from 'svelte'
    import ProvidersMethods from '../$methods/providers.methods'

    const dispatch = createEventDispatcher()

    export let partner = ''
    export let provider = ''
    export let label = 'Partner'
    export let providerLabel = 'Proveedor'
    export let hideLabels = false
    export let size = ''
    export let options = null
    export let askProvider = true

    const providers = ProvidersMethods.getProviders()
    const defaultPartners = [
        ...ProvidersMethods.getPartners(),
        ...ProvidersMethods.getProviders(),
    ]

    $: partners = (options || defaultPartners).map(item => {
        return typeof item === 'string' ? { value: item, text: item } : item
    })

    $: needsProvider = askProvider && partner && !providers.includes(partner)

    function onPartnerSelect() {
        provider = providers.includes(partner) ? partner : ''
        dispatch('select')
    }

    function onProviderSelect() {
        dispatch('select')
    }

</script>
<!-- svelte-ignore a11y-no-onchange -->

<div class="field">
    {#if !hideLabels}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <div class="select is-fullwidth" class:is-small={size === 'small'}>
            <select bind:value={partner} on:change={onPartnerSelect}>
                <option value="">Partner</option>
                {#each partners as partnerItem}
                    <option value="{ partnerItem.value }">{ partnerItem.text }</option>
                {/each}
            </select>
        </div>
    </div>
</div>

{#if needsProvider}
    <div class="field">
        {#if !hideLabels}
            <label for="" class="label">{ providerLabel }</label>
        {/if}
        <div class="control">
            <div class="select is-fullwidth" class:is-small={size === 'small'}>
                <select bind:value={provider} on:change={onProviderSelect}>
                    <option value="">Proveedor</option>
                    {#each providers as providerItem}
                        <option value="{ providerItem }">{ providerItem }</option>
                    {/each}
                </select>
            </div>
        </div>
    </div>
{/if}
